import { render, staticRenderFns } from "./AgeRestriction.vue?vue&type=template&id=43e19570&scoped=true&"
import script from "./AgeRestriction.vue?vue&type=script&lang=js&"
export * from "./AgeRestriction.vue?vue&type=script&lang=js&"
import style0 from "./AgeRestriction.vue?vue&type=style&index=0&id=43e19570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e19570",
  null
  
)

export default component.exports